import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition = ({ children, theme }) => {
  const location = useLocation();
  const videoRef = useRef(null);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [content, setContent] = useState(children);
  const timeoutRef = useRef(null);
  const mountedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (isTransitioning && videoRef.current) {
      videoRef.current.volume = 0.1;
    }
  }, [isTransitioning]);

  useEffect(() => {
    const handleTransition = async () => {
      console.log('Transition triggered, mounted:', mountedRef.current);
      
      if (!mountedRef.current) {
        console.log('Component not mounted, skipping transition');
        return;
      }

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      setIsTransitioning(true);
      
      // Wait for video element to be available
      await new Promise(resolve => setTimeout(resolve, 0));
      
      const video = videoRef.current;
      if (!video) {
        console.error('Video ref still not found after mount');
        setContent(children);
        setIsTransitioning(false);
        return;
      }

      try {
        video.currentTime = 0;
        await video.load();
        await video.play();
        
        timeoutRef.current = setTimeout(() => {
          if (mountedRef.current) {
            setContent(children);
          }
        }, theme.video.transitionPause);

        timeoutRef.current = setTimeout(() => {
          if (mountedRef.current) {
            setIsTransitioning(false);
          }
        }, theme.video.transitionDuration);

      } catch (error) {
        console.error('Transition failed:', error);
        setContent(children);
        setIsTransitioning(false);
      }
    };

    handleTransition();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [location.pathname, children, theme]);

  return (
    <div className="relative">
      {content}
      {isTransitioning && (
        <>
          <video
            ref={videoRef}
            className="fixed inset-0 w-screen h-screen object-cover mix-blend-multiply dark:mix-blend-screen pointer-events-none z-50"
            src={theme.video.transition}
            playsInline
            preload="auto"
          />
        </>
      )}
    </div>
  );
};

export default PageTransition;